(function() {
    let lastModified = Date.now();

    function checkForChanges() {
        fetch('/development_build.txt?' + Date.now(), {
            method: 'HEAD'
        }).then(response => {
            const currentModified = new Date(response.headers.get('Last-Modified'));
            if (currentModified > lastModified) {
                lastModified = currentModified;
                window.location.reload();
            }
        }).finally(() => {
            setTimeout(checkForChanges, 500);
        });
    }

    checkForChanges();
})();